<template>
    <section class="section-padding">
        <div class="add-padding">
            <div class="row columns">
                <div class="col-md-7 d-flex flex-column justify-content-center">
                    <h2 class="titre-section mb-50">
                        <span class="span-background">
                            Emci s’engage dans le mécenat
                        </span>
                    </h2>
                    <div class="textDescription">
                        <p class="mb-20">
                            Linga Tere est une ONG culturelle engagée dans l'art et le développement implantée dans le
                            quartier de Galabadja à Bangui (en centre Afrique) et fondée par Vincent Mambachaka. Depuis
                            plusieurs années, E.M.C.I. soutient l'action de Linga Terre, notamment par le don de
                            matériel informatique et de bureau.
                        </p>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="d-flex imgSection h-100">
                        <div class="w-50">
                            <img class="h-100" src="/images/valeur/valeur3.png" alt="Valeur EMCI">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

</script>

<style scoped>
.titre-section {
    text-align: left;
    font-size: 50px;
    font-family: Nunito;
    font-weight: 600;
}

ul {
    list-style-type: disc;
    margin: 0 2rem;
    padding: initial;
}

.textDescription p,
.textDescription li {
    font-family: Inter;
    font-size: 18px;
}

.btn-transparent {
    font-size: 20px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    line-height: 135%;
    letter-spacing: 0.8px;
    padding: 15px 25px;
}

.btn-transparent:hover {
    color: #fff;
    background: linear-gradient(93deg, #318EC7 9.92%, #E94B54 52.75%, #FAB74B 88.05%);
}

.fa-quote-right,
.fa-quote-left {
    color: #83C1E8;
    font-size: 48px;
}

.imgSection {
    border-radius: 9px;
    justify-content: center;
}

.imgSection img {
    object-fit: cover;
    border-radius: 10px;
    box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.08);
}

.textSection {
    padding: 42px 24px;
}

.textSection p {
    color: #25233E;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 144%;
    letter-spacing: 0.72px;
}

.nameRef {
    color: var(--tertiaire, #318EC7);
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 144%;
    letter-spacing: 0.72px;
}

.section-padding {
    padding: 5rem 0;
}



@media only screen and (min-width: 50px) and (max-width: 999px) {
    img .h-100 {
        height: auto !important;
        width: auto !important;
        object-fit: contain;
    }
}

@media only screen and (min-width: 1088px) and (max-width: 1872px) {
    .h-100 .h-100 {
        height: 75% !important;
    }
}
</style>